/*
  Hannah's Style Room - cart discount display for Kaching Cart
  Footer:    "Discounts  [tag 2 ITEMS]   -$20.98" directly above Total.
  Line item: small "[tag 2 ITEMS]" badge under the existing "You save" badge.
  Read-only: uses the real Shopify cart discount data
  (cart_level_discount_applications). Never changes the cart or checkout.
  Remove: delete this file and its <script> line in layout/theme.liquid.
*/
(function () {
  'use strict';
  if (window.__hsrCartDiscountRow) return;
  window.__hsrCartDiscountRow = true;

  // Tier label by the title of the discount Shopify actually applied, e.g.
  // "2+ ITEMS - 15% OFF" or " 3+ ITEMS - 20% OFF". Only the leading item
  // count is read, so the percentage in the title (or the offer) can change.
  var TIERS = { '2': '2 ITEMS', '3': '3+ ITEMS' };

  function tierFromTitle(title) {
    var m = /^\s*(\d+)\s*\+?\s*items?\b/i.exec(String(title == null ? '' : title));
    var key = m ? String(parseInt(m[1], 10)) : '';
    return TIERS[key] ? key : null;
  }

  // Total quantity across all cart lines (not the number of lines).
  function cartQuantity(cart) {
    if (Array.isArray(cart.items)) {
      return cart.items.reduce(function (sum, item) { return sum + (Number(item && item.quantity) || 0); }, 0);
    }
    return Number(cart.item_count) || 0;
  }

  // Display only: the tier is already decided by Shopify's applied discount.
  // Quantity just picks "3 ITEMS" (exactly 3) or "3+ ITEMS" (more) for the 3+ tier.
  function tierLabel(key, cart) {
    if (!key) return null;
    if (key === '3' && cartQuantity(cart) === 3) return '3 ITEMS';
    return TIERS[key];
  }

  var ROW_CLASS = 'hsr-cart-discount-row';
  var LINE_CLASS = 'hsr-cart-tier-line';
  var BADGE_CLASS = 'hsr-cart-tier-badge';
  var STYLE_ID = 'hsr-cart-discount-row-style';
  var SUBTOTAL = '.kaching-cart__subtotal';
  var LINE_PRICE = '.kaching-cart-item__price-info';
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var lastCart = null;
  var fetched = false;
  var queued = false;

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.' + ROW_CLASS + '{display:flex;justify-content:space-between;align-items:center;' +
      'gap:12px;width:100%;box-sizing:border-box;margin:0;padding:0;' +
      'font-size:14px;line-height:1.3;font-weight:400;color:#111;background:none;}' +
      '.' + ROW_CLASS + '__left{display:flex;align-items:center;gap:8px;min-width:0;}' +
      '.' + ROW_CLASS + '__amount{white-space:nowrap;font-weight:500;}' +
      '.' + BADGE_CLASS + '{display:inline-flex;align-items:center;gap:4px;box-sizing:border-box;' +
      'padding:2px 6px;border:1px solid #d0d5dd;border-radius:4px;background:#f9fafb;' +
      'color:#475467;font-size:11px;line-height:1.2;font-weight:600;letter-spacing:.02em;' +
      'text-transform:uppercase;white-space:nowrap;}' +
      '.' + BADGE_CLASS + ' svg{width:11px;height:11px;flex:0 0 auto;display:block;}' +
      '.' + LINE_CLASS + '{display:flex;justify-content:flex-end;margin-top:4px;}';
    document.head.appendChild(s);
  }

  function makeBadge(text) {
    var badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z');
    var dot = document.createElementNS(SVG_NS, 'circle');
    dot.setAttribute('cx', '7');
    dot.setAttribute('cy', '7');
    dot.setAttribute('r', '1.2');
    svg.appendChild(path);
    svg.appendChild(dot);
    var label = document.createElement('span');
    label.textContent = text;
    badge.appendChild(svg);
    badge.appendChild(label);
    return badge;
  }

  function setBadgeText(badge, text) {
    if (badge.lastChild.textContent !== text) badge.lastChild.textContent = text;
  }

  // A cart object is usable only if it carries Shopify's discount fields.
  function usable(cart) {
    return !!cart && Array.isArray(cart.cart_level_discount_applications);
  }

  function money(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = '';
    try { fmt = (window.__kachingCartProps && window.__kachingCartProps.moneyFormat) || ''; } catch (e) {}
    fmt = String(fmt).replace(/<[^>]*>/g, '');
    if (/\{\{\s*amount\s*\}\}/.test(fmt)) return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas);
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return '$' + withCommas;
  }

  // Returns {tier, amount} from the real Shopify discount, or null when none is applied.
  function describe(cart) {
    if (!usable(cart)) return null;
    // Shopify's /cart.js lists the application directly; Kaching's cart state
    // wraps the same Shopify object in { amount, discount_application }.
    var apps = cart.cart_level_discount_applications.map(function (a) {
      return (a && a.discount_application) || a;
    }).filter(function (a) {
      return a && Number(a.total_allocated_amount) > 0;
    });
    if (!apps.length) return null;
    var total = apps.reduce(function (sum, a) { return sum + Number(a.total_allocated_amount); }, 0);
    var tier = null;
    if (apps.length === 1) tier = tierLabel(tierFromTitle(apps[0].title), cart);
    return { tier: tier, amount: '-' + money(total) };
  }

  function renderFooter(info) {
    var subtotal = document.querySelector('kaching-cart ' + SUBTOTAL) || document.querySelector(SUBTOTAL);
    var rows = document.querySelectorAll('.' + ROW_CLASS);
    var keep = null;

    if (subtotal && info) {
      var prev = subtotal.previousElementSibling;
      if (prev && prev.classList.contains(ROW_CLASS)) keep = prev;
    }
    for (var i = 0; i < rows.length; i++) {
      if (rows[i] !== keep) rows[i].remove();
    }
    if (!subtotal || !info) return;

    if (!keep) {
      keep = document.createElement('div');
      keep.className = ROW_CLASS;
      var left = document.createElement('span');
      left.className = ROW_CLASS + '__left';
      var word = document.createElement('span');
      word.textContent = 'Discounts';
      left.appendChild(word);
      var amount = document.createElement('span');
      amount.className = ROW_CLASS + '__amount';
      keep.appendChild(left);
      keep.appendChild(amount);
      subtotal.parentNode.insertBefore(keep, subtotal);
    }
    var leftEl = keep.firstChild;
    var badge = leftEl.querySelector('.' + BADGE_CLASS);
    if (info.tier) {
      if (!badge) leftEl.appendChild(makeBadge(info.tier)); else setBadgeText(badge, info.tier);
    } else if (badge) {
      badge.remove();
    }
    if (keep.lastChild.textContent !== info.amount) keep.lastChild.textContent = info.amount;
  }

  function renderLines(info) {
    var tier = info && info.tier;
    var holders = tier ? document.querySelectorAll('kaching-cart ' + LINE_PRICE) : [];
    var wanted = [];
    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      var line = null;
      for (var c = 0; c < holder.children.length; c++) {
        if (holder.children[c].classList.contains(LINE_CLASS)) { line = holder.children[c]; break; }
      }
      if (!line) {
        line = document.createElement('div');
        line.className = LINE_CLASS;
        line.appendChild(makeBadge(tier));
        holder.appendChild(line);
      } else {
        setBadgeText(line.firstChild, tier);
        if (holder.lastElementChild !== line) holder.appendChild(line);
      }
      wanted.push(line);
    }
    var all = document.querySelectorAll('.' + LINE_CLASS);
    for (var j = 0; j < all.length; j++) {
      if (wanted.indexOf(all[j]) === -1) all[j].remove();
    }
  }

  function render() {
    var info = describe(lastCart);
    if (info) addStyle();
    renderFooter(info);
    renderLines(info);
  }

  function setCart(cart) {
    if (!usable(cart)) return false;
    lastCart = cart;
    render();
    return true;
  }

  // Priority 2: Kaching's own cart state. Priority 3: one /cart.js request.
  function loadCart() {
    var api = window.kachingCartApi;
    var p;
    try { p = api && typeof api.getCartData === 'function' ? api.getCartData() : null; } catch (e) { p = null; }
    Promise.resolve(p).then(function (cart) {
      if (setCart(cart)) return;
      if (lastCart || fetched) { render(); return; }
      fetched = true;
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(setCart);
    }).catch(function () {});
  }

  // Priority 1: Kaching's update event carries the fresh cart.
  document.addEventListener('kaching-cart:cart-updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (!setCart(cart)) loadCart();
  });

  // Small fallback: Kaching re-renders the Total row and line items, so put ours back.
  function watch() {
    var root = document.querySelector('kaching-cart');
    if (!root || root.__hsrWatched) return !!root;
    root.__hsrWatched = true;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        loadCart(); // re-reads Kaching's in-memory cart; no network request
      }, 0);
    }).observe(root, { childList: true, subtree: true });
    return true;
  }

  function init() {
    loadCart();
    if (watch() || !document.body) return;
    // Kaching mounts its drawer late on some pages: wait for it once.
    var wait = new MutationObserver(function () {
      if (watch()) { wait.disconnect(); loadCart(); }
    });
    wait.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { watch(); loadCart(); });
})();
